import React from 'react';
import '../styles/Media.css';
import { CardGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { NEWS_SUBTITLE, NEWS_TITLE } from '../data/navbar/menu';
import NEWS_ARTICLES from '../data/news/news';
import MediaCard from './MediaCard'
import JumboContainer from './common/JumboContainer';

const Media = (props) => {
  const {t} = useTranslation();
  return(
    <JumboContainer id="news" white title={t(NEWS_TITLE)} subtitle={t(NEWS_SUBTITLE)} >
          <div class="articles-group">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <CardGroup>
                {NEWS_ARTICLES.map(item => (
                  <MediaCard
                    key={item.key}
                    image={item.image}
                    title={item.title}
                    headline={item.headline}
                    link={item.link}
                    medianame={item.medianame}
                    medialogo={item.medialogo}/>
                  )
                )}
              </CardGroup>
            </div>
          </div>
    </JumboContainer>
  );
}

export default Media;
